<template>
  <div class="grid gap-4">
    <course-program-enhanced-entry
      v-for="(entry, index) in program"
      :key="index"
      :entry="entry"
    />
  </div>
</template>

<script setup lang="ts">
import type { CoursePageView } from "~/business-areas/course/course.model";
import CourseProgramEnhancedEntry from "~/business-areas/course-program/component/course-program-enhanced-entry.vue";
import { useCourseProgramEnhanced } from "~/business-areas/course-program/composables/course-program-enhanced.hook";
import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";

const properties = defineProps<{
  course: CoursePageView;
  nextSession?: CourseSessionView;
}>();

const program = useCourseProgramEnhanced(
  computed(() => ({
    course: properties.course,
    session: properties.nextSession,
  })),
);
</script>
